import styles from "./Confirmation.module.css";
import { useEsCliente } from "../../../../../../shared/hooks/useTenantTipo";
import { useLang } from "../../../../../../shared/i18n/useLang";

function InfoRow({ label, value }) {
  if (!value && value !== 0) return null;
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value} title={String(value)}>{value}</span>
    </div>
  );
}

function Section({ icon, title, color = "#f97316", children }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <div className={styles.iconBox} style={{ background: `${color}14`, border: `1px solid ${color}28` }}>
          <i className={`fa-solid ${icon}`} style={{ color, fontSize: "0.85rem" }} />
        </div>
        <span className={styles.sectionTitle}>{title}</span>
      </div>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  );
}

function CountBadge({ count, label, icon, color }) {
  return (
    <div className={styles.badge}>
      <i className={`fa-solid ${icon}`} style={{ color, fontSize: "0.78rem" }} />
      <span className={styles.badgeCount} style={{ color }}>{count}</span>
      <span className={styles.badgeLabel}>{label}</span>
    </div>
  );
}

export default function Confirmation({ formData }) {
  const esCliente = useEsCliente();
  const L = useLang();
  const p = formData.propietario;
  const nombreMostrado = (p.nombre_sociedad || `${p.nombre || ""} ${p.apellidos || ""}`).trim();
  return (
    <div className="step">

      {/* ── Header ── */}
      <div className={`${styles.header} mt-2`}>
        <div className={styles.headerIcon}>
          <i className="fa-solid fa-clipboard-check" style={{ color: "#f97316" }} />
        </div>
        <div>
          <h3 className={styles.title}>{L("Confirmación y Resumen", "Confirmation & Summary")}</h3>
          <p className={styles.subtitle}>{L("Verificá que los datos sean correctos antes de guardar", "Check that the data is correct before saving")}</p>
        </div>
      </div>

      {/* ── Card ── */}
      <div className={styles.card}>

        {/* Card header */}
        <div className={styles.cardHeader}>
          <i className="fa-solid fa-list-check" style={{ color: "#f97316" }} />
          <span>{L("Resumen de la información", "Information summary")}</span>
        </div>

        <div className={styles.grid}>

          {/* Identificación */}
          <Section icon="fa-house" title={esCliente ? L("Cliente", "Client") : L("Filial", "Unit")} color="#f97316">
            <InfoRow label={esCliente ? L("ID / Código", "ID / Code") : "ID Filial"} value={formData.filial.idFilial} />
            {!esCliente && <InfoRow label="N° Plano"          value={formData.filial.numPlano} />}
            {!esCliente && <InfoRow label="N° Folio"          value={formData.filial.numFolio} />}
            {!esCliente && <InfoRow label="Tipo de propiedad" value={formData.filial.tipoPropiedad} />}
          </Section>

          {/* Datos de la persona/cliente */}
          <Section icon="fa-user" title={esCliente ? L("Datos", "Details") : L("Propietario", "Owner")} color="#60a5fa">
            <InfoRow label={L("Nombre", "Name")}          value={nombreMostrado} />
            <InfoRow label={L("Email principal", "Primary email")} value={formData.propietario.emailPrincipal} />
          </Section>

        </div>

        {/* Counts — solo en modo condominio */}
        {!esCliente && (
          <div className={styles.counts}>
            <CountBadge count={formData.copropietarios.length}
              label="copropietario(s)" icon="fa-users" color="#a78bfa" />
            <span className={styles.countDivider} />
            <CountBadge count={formData.autorizados.length}
              label="autorizado(s)" icon="fa-id-card" color="#4ade80" />
          </div>
        )}

      </div>

      {/* Notice */}
      <div className={`${styles.notice} d-flex align-items-center`}>
        <i className="fa-solid fa-circle-info" style={{ color:"#60a5fa", flexShrink:0 }} />
        <span>{L(`Al confirmar se creará el ${esCliente ? "cliente" : "residente"} y todos sus datos asociados.`,
                 `Confirming will create the ${esCliente ? "client" : "resident"} and all associated data.`)}</span>
      </div>

    </div>
  );
}
